import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=af045db0"
import script from "./product_list.vue?vue&type=script&lang=js"
export * from "./product_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af045db0')) {
      api.createRecord('af045db0', component.options)
    } else {
      api.reload('af045db0', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=af045db0", function () {
      api.rerender('af045db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/big_meeting/form/product_list.vue"
export default component.exports